import siteApi from '../clients/site';
import siteLockspaceApi from '../clients/site-lockspace';

export const generateSiteSearchKey = async (): Promise<string> => {
  const { data } = await siteApi.post<string>('/generate-search-key');

  return data;
};

export const generateSiteLockspaceSearchKey = async (): Promise<string> => {
  const { data } = await siteLockspaceApi.post<string>('/generate-search-key');

  return data;
};
